import type { ReactElement } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface LoadingBarProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingBar = ({
  className,
  baseContainerClasses,
}: LoadingBarProps): ReactElement => (
  <div className={classNames(baseContainerClasses, "gap-4", className)}>
    <div className="bg-tertiary h-6 w-1/2 animate-pulse rounded-full" />
    <div className="flex h-64 flex-col justify-end gap-2">
      <div className="flex items-end justify-between gap-2">
        {Array.from({ length: 6 }, (_, index) => (
          <div
            key={`bar-${index}`}
            className={classNames(
              "bg-tertiary w-full animate-pulse rounded-t-md",
              index % 3 === 0 ? "h-32" : index % 2 === 0 ? "h-20" : "h-40",
            )}
          />
        ))}
      </div>
      <div className="flex justify-between">
        {Array.from({ length: 6 }, (_, index) => (
          <div
            key={`bar-label-${index}`}
            className="bg-tertiary h-4 w-12 animate-pulse rounded-full"
          />
        ))}
      </div>
    </div>
  </div>
);
